import { AccountingFilter, AccountingLoanEntry, AccountingType } from 'v2-types/order';

export const getAccountingEntriesByKind = ({ accounting, kind }: { accounting: AccountingType[], kind: AccountingFilter }) => accounting.filter((entry) => entry.kind === kind);
export const getAccountingEntryByLedgerCode = ({ accounting, ledgerCode }: {accounting: AccountingType[], ledgerCode: string}) => accounting.find((entry) => entry.code === ledgerCode);

export const orderAccountingLoanEntriesByDescription = (accounting: AccountingLoanEntry[]) => accounting.sort((entryA, entryB) => entryA.description[0].localeCompare(entryB.description[0]));
export const filterAccountingEntriesByLoanId = (accounting: AccountingLoanEntry[], loanId: string) => {
  return orderAccountingLoanEntriesByDescription(accounting).filter(entry => entry.code.includes(loanId));
};
